(function () {
  var root = document.querySelector('[data-ilmas-pdp]');
  if (!root) return;

  var mainImg = root.querySelector('[data-ilmas-main-img]');
  var thumbs = root.querySelectorAll('[data-ilmas-thumb]');
  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      var src = btn.getAttribute('data-src');
      var srcset = btn.getAttribute('data-srcset');
      var alt = btn.getAttribute('data-alt') || '';
      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      mainImg.alt = alt;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === btn);
        t.setAttribute('aria-pressed', t === btn ? 'true' : 'false');
      });
    });
  });

  var jsonEl = root.querySelector('[data-ilmas-product-json]');
  var productData = null;
  try { productData = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { productData = null; }

  var optionSelects = root.querySelectorAll('[data-ilmas-option]');
  var quoteEls = root.querySelectorAll('[data-ilmas-cta-quote]');
  var waEls = root.querySelectorAll('[data-ilmas-cta-wa]');
  var pvpEl = root.querySelector('[data-ilmas-pvp]');
  var title = (productData && productData.title) || root.getAttribute('data-product-title') || '';

  function selectedOptions() {
    var opts = [];
    optionSelects.forEach(function (sel) {
      opts.push({
        name: sel.getAttribute('data-option-name') || '',
        value: sel.value,
        index: parseInt(sel.getAttribute('data-option-index'), 10) || 0
      });
    });
    return opts;
  }

  function findVariant() {
    if (!productData || !productData.variants) return null;
    var sels = selectedOptions();
    if (!sels.length) return productData.variants[0] || null;
    return productData.variants.find(function (v) {
      return sels.every(function (s) {
        var key = 'option' + (s.index + 1);
        return String(v[key] || '') === String(s.value);
      });
    }) || productData.variants[0] || null;
  }

  function productLabel(variant) {
    var parts = selectedOptions().map(function (s) { return s.name + ': ' + s.value; });
    if (!parts.length && variant && variant.title && variant.title !== 'Default Title') {
      return title + ' — ' + variant.title;
    }
    if (!parts.length) return title;
    return title + ' — ' + parts.join(' / ');
  }

  function updateCtas(variant) {
    var label = productLabel(variant);
    quoteEls.forEach(function (a) { a.setAttribute('data-ilmas-product', label); });
    var wa = 'https://wa.me/34646474297?text=' + encodeURIComponent(label);
    waEls.forEach(function (a) { a.href = wa; });
  }

  function updatePrice(variant) {
    if (!pvpEl) return;
    if (!variant || !variant.price || variant.price === 0) {
      pvpEl.innerHTML = '<span class="ilmas-pdp__price-budget">Presupuesto de instalación</span>';
      return;
    }
    pvpEl.innerHTML =
      '<span class="ilmas-pdp__price-money" data-ilmas-pvp-money></span>' +
      '<span class="ilmas-pdp__price-note">orientativo, instalación aparte</span>';
    var money = pvpEl.querySelector('[data-ilmas-pvp-money]');
    if (money) money.textContent = variant.price_money || '';
  }

  function onOptionChange() {
    var variant = findVariant();
    updateCtas(variant);
    updatePrice(variant);
  }

  optionSelects.forEach(function (sel) {
    sel.addEventListener('change', onOptionChange);
  });
  onOptionChange();
})();
